import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestService } from './rest.service';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class ReferralsService extends RestService {
    public url: string;

    constructor(protected http: HttpClient) {
        super(http);
        this.url = environment.api + '/referrals';
    }
}